import React, { useState } from 'react';
import { Link, useHistory, Redirect } from 'react-router-dom';
import AuthLayout from '../../components/AuthLayout';
import Logo from '../../assets/images/logo.png';
import UserIcon from '../../components/icons/UserIcon';
import LockIcon from '../../components/icons/LockIcon';
import { useAuth } from '../../contexts/AuthContext';

const Login = () => {
  const { currentUser, signin } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({
    email: '',
    password: '',
  });

  const [userDataError, setUserDataError] = useState({
    email: '',
    password: '',
  });

  const history = useHistory();

  const validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  const validateInput = (value, name) => {
    if (!value) {
      setUserDataError((userDataError) => ({
        ...userDataError,
        [name]: 'This field should not be empty.',
      }));
      return false;
    } else {
      if (name === 'email') {
        const emailValid = validateEmail(value);
        if (!emailValid) {
          setUserDataError((userDataError) => ({
            ...userDataError,
            [name]: 'Invalid e-mail address',
          }));
          return false;
        } else {
          setUserDataError((userDataError) => ({ ...userDataError, [name]: '' }));
          return true;
        }
      } else {
        setUserDataError((userDataError) => ({ ...userDataError, [name]: '' }));
        return true;
      }
    }
  };

  const handleChange = (e) => {
    validateInput(e.target.value, e.target.name);
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = () => {
    setError('');
    setLoading(true);

    const result = Object.keys(user).map((key) => {
      return validateInput(user[key], key);
    });

    const isInvalid = result.filter((r) => !r).length > 0;

    if (isInvalid) {
      return;
    }

    signin(user.email, user.password)
      .then((ref) => {
        setLoading(false);
        history.push('/dashboard');
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };

  if (currentUser) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <AuthLayout>
      <div className="auth-login">
        <div className="auth-container">
          <div className="half-section">
            <div className="auth-text">
              <img src={Logo} alt="" className="logo" />
              <h1>
                Hello, Welcome to <span>We All Count’s</span> Funding Web tool.
              </h1>
            </div>
          </div>
          <div className="half-section">
            <div className="auth-card">
              <h2>Log into Your account</h2>
              <div className={`auth-form ${userDataError.email ? 'error' : ''}`}>
                <div className="main-image">
                  <UserIcon color={userDataError.email ? '#F98784' : '#594FD1'} />
                </div>
                <div className="main-input">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={user.email}
                    onChange={handleChange}
                  />
                </div>
              </div>
              {userDataError.email && <p className="error-msg">{userDataError.email}</p>}
              <div className={`auth-form ${userDataError.password ? 'error' : ''}`}>
                <div className="main-image">
                  <LockIcon color={userDataError.password ? '#F98784' : '#594FD1'} />
                </div>
                <div className="main-input">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    placeholder="Password"
                    name="password"
                    value={user.password}
                    onChange={handleChange}
                  />
                </div>
              </div>
              {userDataError.password && <p className="error-msg">{userDataError.password}</p>}
              {error && <p className="error-msg">{error}</p>}
              <Link to="/forgot-password" className="forgot">
                Forgot password?
              </Link>
              <div className="actions">
                <button className="primary-btn" onClick={() => handleLogin()}>
                  Log in
                </button>
              </div>
              <p className="question-text">Don’t have an account?</p>
              <div className="text-center">
                <Link to="/signup" className="link">
                  Click here to Register
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Login;
